import { useRouter } from 'next/router';
import { NextPage } from 'next';

import { Head } from '@keaze/web/components';
import { Search } from '@keaze/web/views/search';
import { QueryParams, OccupancyType } from '@keaze/web/common/enums';

const SearchPage: NextPage = () => {
  const router = useRouter();
  const location = router.query[QueryParams.Location] as string;
  const generatedLocationTitle = location ? ` | ${location}` : '';
  const occupancyTypeName =
    router.query[QueryParams.OccupancyType] === OccupancyType.Sale
      ? 'for sale'
      : 'to rent';
  const title = `Properties ${occupancyTypeName}${generatedLocationTitle}`;

  return (
    <>
      <Head children withBaseSocialMetaTags title={`${title} | Home Stepper`} />
      <Search occupancyTypeName={occupancyTypeName} />
    </>
  );
};

export default SearchPage;
